<template>
  <div class="order-details-box">
    <header class="lmy-header lmy-header-w">
      <i class="iconfont icon-yuyin" onclick="window.history.go(-1)"></i>
      订单详情
    </header>
    <div class="infinite-loading-containers" style="margin-top:1.2rem" v-if="isLoading">
      <i class="loading-defaults"></i>
    </div>
    <div class="top" v-if="!isLoading">
      <div class="txt">
        <p class="order-type" v-if="bookInfo.OrderStatus === 0">未支付</p>
        <p class="order-type" v-else-if="bookInfo.OrderStatus === 1">处理中</p>
        <p class="order-type" v-else-if="bookInfo.OrderStatus === 2">已支付</p>
        <p class="order-type" v-else-if="bookInfo.OrderStatus === 4">已退款</p>
        <p class="order-type" v-else-if="bookInfo.OrderStatus === 5">已取消</p>
        <p v-if="bookInfo.OrderStatus === 0">由于价格变动频繁，请尽快支付</p>
        <p v-if="bookInfo.OrderStatus === 2">订单已经支付，欢迎再次订购</p>
        <p v-if="bookInfo.OrderStatus === 4 ||bookInfo.OrderStatus === 5 ">订单已经关闭</p>
        <div class="btn-box">
          <p class="active btn" v-if="bookInfo.OrderStatus==0" @click="routeToPay(bookInfo)">立即支付</p>
          <!-- <p class="btn" v-if="bookInfo.OrderStatus==0" @click="bookAgain()">再次订购</p> -->
        </div>
      </div>
    </div>
    <div class="middle" v-if="!isLoading">
      <div class="order-price flow">
        <p>总计：
          <span class="sym">￥</span>
          <span class="num">{{bookInfo.TotalAmount}}</span>
        </p>
        <p class="tip">即订即保，订单一经确认，不可取消、更改</p>
      </div>
    </div>
    <div class="bottom" v-if="!isLoading">
      <div class="details">
        <p class="title">订单信息</p>
        <ul>
          <li>
            <span class="lable">订单编号：</span>
            <span>{{bookInfo.OrderNO}}</span>
          </li>
          <li>
            <span class="lable">产品名称：</span>
            <span>{{bookInfo.PresaleName}}</span>
          </li>
          <li>
            <span class="lable">产品份数：</span>
            <span>{{bookInfo.Count}}份</span>
          </li>
          <li>
            <span class="lable">限用期限：</span>
            <span>{{bookInfo.UseTimeFrom|dateYYMMDD}} 到 {{bookInfo.UseTimeTo|dateYYMMDD}}</span>
          </li>
          <li v-if="bookInfo.PayOn">
            <span class="lable">下单时间：</span>
            <span>{{bookInfo.PayOn|dateLong}}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="bottom" v-if="!isLoading">
      <div class="details">
        <p class="title">联系信息</p>
        <ul v-if="bookInfo.ReceiverName">
          <li>
            <span class="lable">收货人：</span>
            <span>{{bookInfo.ReceiverName}}</span>
          </li>
          <li>
            <span class="lable">收货电话：</span>
            <span>{{bookInfo.ReceiverPhone}}</span>
          </li>
          <li>
            <span class="lable">收货地址：</span>
            <span>{{bookInfo.ReceiveAddress}}</span>
          </li>
        </ul>
        <ul v-if="!bookInfo.ReceiverName">
          <li>
            <span class="lable">联系电话：</span>
            <span>{{bookInfo.Phone}}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="bottom" v-if="!isLoading && bookInfo.SubOrders.length>0">
      <div class="details">
        <p class="title">预售编码</p>
        <div class="certificate">
          <div class="name" v-for="(sub,index) in bookInfo.SubOrders">
            <p class="one">第{{index+1}}份</p>
            <p class="two">
              {{sub.Code}}
              <span v-if="sub.IsUsed">已使用</span>
              <span v-if="!sub.IsUsed">未使用</span>
              关联订单号
              <span>{{sub.FinallyOrderNO}}</span>
            </p>
          </div>
          <!-- <div class="name">
            <p class="one">第1份</p>
            <p class="two">
              123456
              <span>已使用</span>
              关联订单号
              <span>44789</span>
            </p>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Clipboard from "clipboard";
export default {
  name: "presale-order-details",
  data() {
    return {
      bookInfo: {},
      days: 0,
      isLoading: true
    };
  },
  methods: {
    bookAgain() {},
    copyOrderNumber() {
      var clipboard = new Clipboard(".copyOrderNumber");
      var that = this;
      clipboard.on("success", e => {
        // console.log('复制成功')
        that.$alert("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", e => {
        // 不支持复制
        that.$alert("该浏览器不支持自动复制");
        // console.log('该浏览器不支持自动复制')
        // 释放内存
        clipboard.destroy();
      });
    },
    routeToPay(order) {
      this.dao.set("thisBookingOrderNO", order.OrderNO);
      this.$router.push({
        path: "/presaleWxPay",
        query: { OrderNO: order.OrderNO }
      });
    },
    getSaleOrderDetails() {
      this.isLoading = true;
      var that = this;
      var OrderNO = this.$route.query.OrderNO;
      var param = {
        orderNO: OrderNO
      };
      that
        .getRequest({
          url: that.Api.getSaleOrderDetails,
          params: param
        })
        .then(res => {
          if (res && res.IsSuccess) {
            that.bookInfo = res.Result;
            this.isLoading = false;
            // that.days=that.getDays(that.getDates(res.Result.CheckIn),that.getDates(res.Result.CheckOut));
          }
        });
    }
  },
  mounted() {
    this.getSaleOrderDetails();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/usr/myPresaleOrder/details.vue